export enum AgentStatusEnum {
  SimulatingCall = 'SimulatingCall',
  LoggedOut = 'LoggedOut',
  LoggedIn = 'LoggedIn',
  Connecting = 'Connecting',
  Disconnected = 'Disconnected',
  Available = 'Available',
  InboundContact = 'InboundContact',
  OutboundContact = 'OutboundContact',
  Unavailable = 'Unavailable',
  Acw = 'Acw',
  Dialer = 'Dialer',
  InboundConsult = 'InboundConsult',
  OutboundConsult = 'OutboundConsult',
}

export const AgentStatusEnumDisplayName = {
  [AgentStatusEnum.SimulatingCall]: 'Simulating Call',
  [AgentStatusEnum.LoggedOut]: 'Logged Out',
  [AgentStatusEnum.LoggedIn]: 'Logged In',
  [AgentStatusEnum.Connecting]: 'Connecting',
  [AgentStatusEnum.Disconnected]: 'Disconnected',
  [AgentStatusEnum.Available]: 'Available',
  [AgentStatusEnum.InboundContact]: 'On Call',
  [AgentStatusEnum.OutboundContact]: 'On Call',
  [AgentStatusEnum.Acw]: 'ACW',
  [AgentStatusEnum.Unavailable]: 'Unavailable',
  [AgentStatusEnum.Dialer]: 'Dialing',
  [AgentStatusEnum.InboundConsult]: 'Consulting',
  [AgentStatusEnum.OutboundConsult]: 'Consulting',
} satisfies Record<AgentStatusEnum, string>;

export const AgentStatusEnumColor = {
  [AgentStatusEnum.SimulatingCall]: 'blue',
  [AgentStatusEnum.LoggedOut]: 'white',
  [AgentStatusEnum.LoggedIn]: 'white',
  [AgentStatusEnum.Connecting]: 'white',
  [AgentStatusEnum.Disconnected]: 'white',
  [AgentStatusEnum.Available]: 'green',
  [AgentStatusEnum.InboundContact]: 'orange',
  [AgentStatusEnum.OutboundContact]: 'orange',
  [AgentStatusEnum.Acw]: 'orange',
  [AgentStatusEnum.Unavailable]: 'red',
  [AgentStatusEnum.Dialer]: 'orange',
  [AgentStatusEnum.InboundConsult]: 'orange',
  [AgentStatusEnum.OutboundConsult]: 'orange',
} satisfies Record<AgentStatusEnum, string>;
